// import { appName } from '@/constants'
// import { i18n } from '@/utils/i18n'

// export default function setPageTitle(name?: string): void {
//   window.document.title = name ? `${i18n.global.t(`navbar.${name}`)} - ${appName()}` : appName()
// }
import { appName } from '@/constants'
export default function setPageTitle(): void {
  window.document.title = appName()
}
